import React, { useEffect, useState } from "react";
import styles from "./RenderSelectedCollections2.module.css";
import { Button, Thumbnail } from "@shopify/polaris";
import CloseIcon from "../Icons/CloseIcon";

import { CollectionIcon } from "@shopify/polaris-icons";

const RenderSelectedCollections2 = ({
    collections,
    submit,
    multiple = true,
    handleFieldChange = () => {},
}: {
    collections: any;
    submit: any;
    multiple?: boolean | number;
    bundleType?: string;
    handleFieldChange?: any;
}) => {
    const [renderCollectionsArr, setRenderCollectionsArr] = useState([]);

    useEffect(() => {
        if (collections?.length) {
            submit();
        }
        setRenderCollectionsArr(collections);

        return () => {
            if (collections?.length) {
                submit();
            }
        };
    }, [collections]);

    const handleCollectionSearch = async (initialQuery: string = "") => {
        const preSelected = collections?.map((collection: any) => ({
            id: collection.id,
        }));
        const selected = await shopify.resourcePicker({
            type: "collection",
            multiple: multiple,
            query: initialQuery,
            action: "select",
            selectionIds: preSelected,
            filter: {
                // query: "status:active",
                // variants: false,
            },
        });
        console._log("selected", selected);

        const collectionsArr: any = [];

        if (selected) {
            selected?.map((coll: any) => {
                collectionsArr.push({
                    id: coll?.id,
                    handle: coll?.handle,
                    image: coll.image,
                    title: coll.title,
                });
            });

            handleFieldChange(collectionsArr);
        }
    };

    const removeCollection = (pId: string = "") => {
        const temp = [...renderCollectionsArr];
        let idx: number | undefined = -1;
        idx = temp.findIndex((p: any) => p.id == pId);

        if (idx >= 0) {
            temp.splice(idx, 1);

            handleFieldChange(temp);
        }
    };
    return (
        <div>
            <div className={styles.comboTitleWrapper}>
                {renderCollectionsArr?.length == 0 && (
                    <div className={styles.emptyCollectionBox} onClick={() => handleCollectionSearch()}>
                        <Button variant={"secondary"}>Add Collection{multiple == 1 ? "" : "s"}</Button>
                    </div>
                )}

                {renderCollectionsArr?.length > 0 && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            border: "1px solid rgba(227,227,227,1)",
                            borderRadius: "12px",
                            margin: "6px 0",
                        }}
                    >
                        {renderCollectionsArr?.map((coll: any) => (
                            <div className={styles.container} style={{ border: "1px solid green" }}>
                                <div className={styles.container_wrapper}>
                                    <div className={styles.img_container}>
                                        <Thumbnail
                                            source={coll?.image?.originalSrc || CollectionIcon}
                                            alt={coll?.title}
                                            size={"small"}
                                        />
                                    </div>
                                    <p>{coll?.title}</p>
                                </div>

                                <div
                                    onClick={() => {
                                        removeCollection(coll.id);
                                    }}
                                    className={styles.closeIcon}
                                >
                                    <CloseIcon />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RenderSelectedCollections2;
